import { render, staticRenderFns } from "./studentStatisticsTrackMerging.vue?vue&type=template&id=2faee64a"
import script from "./studentStatisticsTrackMerging.vue?vue&type=script&lang=js"
export * from "./studentStatisticsTrackMerging.vue?vue&type=script&lang=js"
import style0 from "./studentStatisticsTrackMerging.vue?vue&type=style&index=0&id=2faee64a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports